import { render, staticRenderFns } from "./newCustomers.vue?vue&type=template&id=3e923360&scoped=true&"
import script from "./newCustomers.vue?vue&type=script&lang=js&"
export * from "./newCustomers.vue?vue&type=script&lang=js&"
import style0 from "./newCustomers.vue?vue&type=style&index=0&id=3e923360&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e923360",
  null
  
)

export default component.exports